module.exports = __webpack_public_path__ + "static/img/yuan_b.bdd73ad8.png";